@if ({ basketNotification: basketNotification$ | async, isOnBasketRoute:
isOnBasketRoute$ | async, basketLink: basketLink$ | async, basketCurrency:
basketCurrency$ | async, basketQuantity: basketQuantity$ | async, basketValue:
basketValue$ | async, showNavigateToBasketButton: showNavigateToBasketButton$ |
async, basketHeaderInfo: basketHeaderInfo$ | async, showBasketNotification:
showBasketNotification$ | async }; as ctx) { @if (basketLoading$ | async) {
<span class="align-self-center text-muted"
  ><fa-icon [icon]="['fas', 'spinner']" [spin]="true" [pulse]="true"></fa-icon
></span>
} @if (ctx.basketLink) {
<a
  class="nav-link h-100 p-2"
  data-e2e="c-basket-icon"
  [ngClass]="{
    active: ctx.isOnBasketRoute,
    'value-change': valueChange
  }"
  (click)="basketNavigation()"
>
  <span class="d-flex align-items-center">
    <fa-icon [icon]="['fas', 'cart-shopping']"></fa-icon>
    @if (ctx.basketQuantity) { @if (ctx.basketQuantity; as totalQuantity) {
    <span class="ml-2 pl-1" data-e2e="basket-quantity"
      >{{ totalQuantity }}
      @if (ctx.basketHeaderInfo?.showPrefix) {
      <span
        i18n="Items|Basket Total Quantity Prefix@@basketTotalQuantityPrefix"
      >
        Item{totalQuantity, plural, =1{} other {s}}
      </span>
      }
    </span>
    } @if ( ctx.basketHeaderInfo?.showTotalBasketValue && ctx.basketValue; as
    totalRequested ) {
    <span data-e2e="basket-total-value" class="ml-1 d-none d-sm-inline">
      ({{
        trimWhitespace(
          totalRequested
            | currency
              : ctx.basketCurrency
              : '&nbsp;' + ctx.basketCurrency + '&nbsp;'
              : '1.2-2'
        )
      }})
    </span>
    } } @else {
    <span
      data-e2e="c-basket-icon-name"
      class="ml-2 d-sm-inline-block d-none"
      i18n="MainNavigation | My Basket Nav Link@@myBasketNavLink:My Basket"
    >
      My Basket
    </span>
    }
  </span>
</a>
} @if (ctx.showBasketNotification) { @if (ctx.basketNotification) {
<epc-basket-notification
  [notification]="ctx.basketNotification"
  [basketLink]="viewInBasketLink$ | async"
  [showNavigateToBasketButton]="ctx.showNavigateToBasketButton"
  [basketValidationErrors]="basketValidationError$ | async"
  (clearNotification)="onClearNotification()"
></epc-basket-notification>
} } }
